import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../../../localization'
import { CustomStepIcon } from './StepIcon'
import { useStyles } from './styles/index.styles'

export default function CustomStepper({
  activeStep = 0
}: {
  activeStep: number
}) {
  const classes = useStyles({ active: false })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const steps = [
    isMobile ? 'Rooms ' : 'Review Room Selected',
    isMobile ? 'Travellers' : 'Traveller & Payment',
    isMobile ? 'Payment ' : 'Complete Booking'
  ]

  return (
    <Stepper
      alternativeLabel={false}
      activeStep={activeStep}
      classes={{ root: classes.main }}
      connector={
        <StepConnector
          classes={{
            alternativeLabel: classes.connectorAlternativeLabel,
            line: classes.connectorLine,
            active: classes.connectorActive,
            completed: classes.connectorCompleted,
            root: classes.connector
          }}
        />
      }>
      {steps.map((label, idx) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(iconProps) => (
              <CustomStepIcon {...iconProps} icon={idx + 1} />
            )}
            classes={{
              root: classes.stepLabelRoot,
              label: classes.stepLabelLabel,
              active: classes.stepLabelActive,
              completed: classes.stepLabelCompleted
            }}>
            {getTranslate(label)}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
